import React from 'react'
import type { Icon } from 'shared/utils'

const TikTok = (props: Icon) => {
    const {
        color = 'white',
        size = 24,
        className = 'tiktok',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <path
                d="M18.176 6.277a4.553 4.553 0 01-.394-.229 5.536 5.536 0 01-1.011-.859 4.77 4.77 0 01-1.14-2.351h.004C15.55 2.329 15.585 2 15.59 2h-3.435v13.282c0 .178 0 .354-.007.529 0 .021-.003.041-.004.065 0 .01 0 .02-.002.03v.007a2.917 2.917 0 01-1.467 2.315 2.867 2.867 0 01-1.422.375 2.906 2.906 0 01-2.897-2.917 2.906 2.906 0 012.897-2.917c.303 0 .604.048.893.142l.004-3.498a6.38 6.38 0 00-4.917 1.439 6.74 6.74 0 00-1.47 1.813c-.145.25-.693 1.255-.759 2.885-.041.926.236 1.884.369 2.28v.009c.083.233.406 1.03.932 1.7a6.98 6.98 0 001.488 1.404v-.008l.009.008C7.464 22.073 9.308 22 9.308 22c.32-.013 1.388 0 2.602-.575 1.347-.638 2.114-1.589 2.114-1.589.49-.567.879-1.215 1.151-1.913.311-.817.415-1.797.415-2.189V8.687c.041.025.596.392.596.392s.8.512 2.047.846c.895.238 2.101.288 2.101.288v-3.41c-.422.046-1.28-.088-2.158-.526z"
                fill={color}
                fillRule="nonzero"
            />
        </svg>
    )
}

export { TikTok }
